import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static values = {
    accepted: Boolean,
  };

  static targets = ["modal"];

  connect() {
    this.modal = new Modal(this.modalTarget);
  }

  disconnect() {
    this.modal.hide();
  }

  requireAgreement(e) {
    if (this.acceptedValue) {
      return true;
    }

    e.preventDefault();
    this.modal.show();
    return false;
  }
}
